module.exports = __webpack_public_path__ + "img/yuanquhexin.e291b16f.png";